export enum ReportType {
    agency =  "agency",
    publisher = "publisher",
    article = "article"
}
